import { BreadcrumbGroup, Button, SpaceBetween, Spinner, StatusIndicator } from '@cloudscape-design/components';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Layout } from '../../components/layout';
import DemoDetails from '../../components/DemoDetails';
import { AdminDemoDefiniton } from '../../types';
import { useAuth } from 'react-oidc-context';
import { getEndpoint } from '../../utils';

export default function AdminDemoDetails() {
    const { path } = useParams();
    const auth = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [demo, setDemo] = useState<AdminDemoDefiniton | null>(null);


    useEffect(() => {
        if (auth.isAuthenticated && !demo) {
            console.log('Loading demos');
            if (!auth.user?.id_token) {
                throw new Error('No id token available');
            }
            auth.startSilentRenew();
            const token = auth.user.id_token;
            if (!token) {
                return;
            }
            auth.startSilentRenew();
            const endpoint = getEndpoint(`/api/admin/demos/${encodeURIComponent(path || '')}`);
            console.log("endpoint", endpoint)
            fetch(endpoint, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            }).then((response) => {
                if (!response.ok) {
                    response.text().then((t) => console.error(t));
                } else {
                    response.json().then((data) => {
                        setDemo(data);
                        setLoading(false);
                    });
                }
            }).catch((e) => {
                console.error(e);
                setLoading(false);
            });

        }
    }, [auth, demo, path]);

    const breadcrumbs = (
        <BreadcrumbGroup
            onClick={({ detail }) => navigate(detail.href)}
            items={[
                { text: "Admin", href: "/admin" },
                { text: demo?.name || "Demo Details", href: `/admin/details/${encodeURIComponent(path || '')}` }
            ]}
        />
    );

    // rum?.recordPageView(`admin/details/${path}`);
    if (!demo) {
        return (
            <Layout breadcrumbs={breadcrumbs}>
                <StatusIndicator type='loading'>Loading Demo Details...</StatusIndicator>
            </Layout>
        );
    }

    return (
        <Layout breadcrumbs={breadcrumbs}>
            {loading && <p>Loading...  <Spinner size="normal" /></p>}
            {demo ? (
                <SpaceBetween size="l">

                    <SpaceBetween size="xs" direction="horizontal">
                        <Button
                            variant="primary"
                            onClick={() => navigate(`/admin/demo/${encodeURIComponent(path ||  '')}/edit`)}>
                            Edit Demo
                        </Button>
                        <Button
                            variant="normal"
                            onClick={() => {
                                // Add delete confirmation and handling
                                console.log('Delete demo:', path);
                            }}>
                            Delete Demo
                        </Button>
                    </SpaceBetween>
                    {demo.rank && <p>Rank: {demo.rank}</p>}
                    <DemoDetails {...demo} />
                </SpaceBetween>
            ) : (
                <p>Demo not found</p>
            )}
        </Layout>
    );
}
